module.exports = __webpack_public_path__ + "img/Cast.6286d956.svg";